import React from "react";

import type { Record } from "~/tools/record";

import { CloseDrawerButton, DrawerTitle, ExplorationDrawer } from "../react/drawer/ExplorationDrawer";

import { Content } from "./_content";
import type { DrawerState } from "./drawer-state";

const STATE_TYPE_TO_TITLE = {
	create: "Add New Widget",
	edit: "Edit Widget",
} satisfies Record<DrawerState["type"]>;

const STATE_TYPE_TO_BUTTON_TEXT = {
	create: "Create widget",
	edit: "Update widget",
} satisfies Record<DrawerState["type"], string>;

const FORM_ID = "setup-dashboard-widget";

export interface SetupDashboardWidgetDrawerProps {
	when: undefined | DrawerState;
}

export const Drawer: React.FC<SetupDashboardWidgetDrawerProps> = ({ when }) => (
	<ExplorationDrawer
		footer={(state) => <Footer {...state} />}
		headerTitle={({ type }) => <DrawerTitle title={STATE_TYPE_TO_TITLE[type]} />}
		id={when?.id}
		when={when}
	>
		{(state, close, preservedState) => (
			<Content
				form={preservedState?.form ?? state.form}
				formId={FORM_ID}
				onSave={(widget) => {
					if (widget != null) {
						state.onSave(widget);
					}
					close();
				}}
				timeRange={state.timeRange}
			/>
		)}
	</ExplorationDrawer>
);

const Footer: React.FC<DrawerState> = ({ type }) => (
	<>
		<CloseDrawerButton />
		<button className="button button-primary uppercase" form={FORM_ID} type="submit">
			{STATE_TYPE_TO_BUTTON_TEXT[type]}
		</button>
	</>
);
